import { lazy } from "react";
import Loadable from "../components/Loadable";

const Learning = Loadable(lazy(() => import("../pages/Learning")));
// const LearningPython = Loadable(lazy(() => import("../pages/Learning/LearningPython")));
const LearningIoTControlSetup = Loadable(lazy(() => import("../pages/Learning/LearningIoTControlSetup")));
const LearningDataRetrieval = Loadable(lazy(() => import("../pages/Learning/LearningDataRetrieval")));
const LearningGrammarCheck = Loadable(lazy(() => import("../pages/Learning/LearningGrammarCheck")));
const LearningBookWriter = Loadable(lazy(() => import("../pages/Learning/LearningBookWriter")));
const LearningGoogleMapsScraper = Loadable(lazy(() => import("../pages/Learning/LearningGoogleMapsScraper")));
const LearningSelfDrivingCar = Loadable(lazy(() => import("../pages/Learning/LearningSelfDrivingCar")));

const SingleCourseInfo = Loadable(lazy(() => import("../pages/Courses/SingleCourseInfo")));
const SignUpCourse = Loadable(lazy(() => import("../pages/Courses/SignUpCourse")));
const SingleCourse = Loadable(lazy(() => import("../pages/Courses/SingleCourse")));
const SignUpCourseReal = Loadable(lazy(() => import("../pages/Courses/SignUpCourseReal")));
const LoginCourseReal = Loadable(lazy(() => import("../pages/Courses/LoginCourseReal")));


const QuizLoading = Loadable(lazy(() => import("../pages/Courses/QuizPage/loading")));
const QuizPage = Loadable(lazy(() => import("../pages/Courses/QuizPage")));
const QuizLoadingArchived = Loadable(lazy(() => import("../pages/Courses/QuizPageArchived/loading")));
const QuizPageArchived = Loadable(lazy(() => import("../pages/Courses/QuizPageArchived")));

const ProjectLoading = Loadable(lazy(() => import("../pages/Courses/ProjectPage/loading")));
const ProjectPage = Loadable(lazy(() => import("../pages/Courses/ProjectPage")));
const ProjectLoadingArchived = Loadable(lazy(() => import("../pages/Courses/ProjectPageArchived/loading")));
const ProjectPageArchived = Loadable(lazy(() => import("../pages/Courses/ProjectPageArchived")));

const SignUpService = Loadable(lazy(() => import("../pages/Services/SignUpService")));

const IdeRoutes2 = [
  { path: "/apps", element: <Learning /> }, 
  // { path: "/apps/python", element: <LearningPython /> },  
  { path: "/apps/iot/control-setup", element: <LearningIoTControlSetup /> }, 
  { path: "/apps/ai/data-knowledge-retrieval", element: <LearningDataRetrieval /> },
  { path: "/apps/ai/grammar-check", element: <LearningGrammarCheck /> },
  { path: "/apps/ai/book-writer", element: <LearningBookWriter /> },
  { path: "/apps/scraper", element: <LearningGoogleMapsScraper /> },
  { path: "/apps/nn-self-driving-car", element: <LearningSelfDrivingCar /> },
  
  { path: "/course/info/:slug", element: <SingleCourseInfo /> },
  { path: "/sign-up/course/:slug", element: <SignUpCourse /> },
  { path: "/course/:slug", element: <SingleCourse /> },

  { path: "/quiz-loading/:quizId", element: <QuizLoading /> },
  { path: "/quiz/:quizId", element: <QuizPage /> },
  { path: "/quiz-loading/archived/:quizId", element: <QuizLoadingArchived /> },
  { path: "/quiz/archived/:quizId", element: <QuizPageArchived /> },

  { path: "/project-loading/:projectId", element: <ProjectLoading /> },
  { path: "/project/:projectId", element: <ProjectPage /> },
  { path: "/project-loading/archived/:projectId", element: <ProjectLoadingArchived /> },
  { path: "/project/archived/:projectId", element: <ProjectPageArchived /> },

  { path: "/sign-up/service/:slug", element: <SignUpService /> },

  { path: "/sign-up/course/:email/:slug", element: <SignUpCourseReal /> },

   { path: "/login/course/:email/:slug", element: <LoginCourseReal /> },



];

export default IdeRoutes2;
